import type { EmojiSearchData } from '../../types'

import styles from './EmojiSuggestion.module.css'

import type { JSX } from 'react'

export const EmojiSuggestion = ({
  emoji,
}: {
  emoji: EmojiSearchData
}): JSX.Element => {
  const { name, skins } = emoji

  // TODO: Add functionality to change skin tones
  // For now, always pick the default skin tone
  const defaultSkin = skins[0]
  const nativeEmoji = defaultSkin.native
  const shortcode = defaultSkin?.shortcodes
  const text = shortcode ? `:${shortcode}:` : name

  return (
    <li className={styles.suggestionItem} data-testid="emoji-suggestion-entry">
      <span>{nativeEmoji}</span>
      <span>{text}</span>
    </li>
  )
}
